import { render, staticRenderFns } from "./BusinessActivityStatement.vue?vue&type=template&id=74d1b0a2&scoped=true"
import script from "./BusinessActivityStatement.vue?vue&type=script&lang=js"
export * from "./BusinessActivityStatement.vue?vue&type=script&lang=js"
import style0 from "./BusinessActivityStatement.vue?vue&type=style&index=0&id=74d1b0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d1b0a2",
  null
  
)

export default component.exports